
import {Component, Prop, Vue} from "vue-property-decorator";
import {translate} from "@/auxillary/translation";

import ReadonlyDataField from "@/models/ReadonlyDataField";

import {findEnumValueSet, activeEnumValues} from "@/auxillary/enum.lookup";

@Component({
  name: 'EnumerationFieldReadonly',
  components: {
  },
})
export default class EnumerationFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get field() {
    return this.dataField;
  }

  get value() {
    return this.dataField?.values?.value
  }

  get enumValues() {
    const enumValues = Array.from(activeEnumValues(this.enumValueSet))
        .map(e => ({code: e.code, displayName: translate(e.displayKey)}));
    if (this.canBeUnknown || this.value == "unknown")
      if (enumValues.find(e => e.code == "unknown") == undefined)
        enumValues.push({code: "unknown", displayName: this.isRow ? "unbekannt" : "Unbekannt"});
    return enumValues
  }

  get isSelect() {
    return this.dataField.definition.ui?.control === "select" || (activeEnumValues(this.enumValueSet).length > 9)
  }

  get isRow() {
    return this.dataField.definition.ui?.direction === "vertical" || (activeEnumValues(this.enumValueSet).length <= 3)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get displayName() {
    if (!this.dataField.displayName)
      return ""
    return this.dataField.displayName;
  }

  get enumValueSet() {
    return findEnumValueSet(this.dataField.definition.enum);
  }

  translate(displayKey: string) {
    return translate(displayKey)
  }
}
